import * as React from 'react';
import { Stack, TextField, InputAdornment, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { TemplateStatus } from '../../../../feature/templates/types';

type Props = {
  search: string;
  status: 'all' | TemplateStatus;
  onSearchChange: (v: string) => void;
  onStatusChange: (v: 'all' | TemplateStatus) => void;
};

export default function TemplatesToolbar({
                                           search,
                                           status,
                                           onSearchChange,
                                           onStatusChange,
                                         }: Props) {
  const handleStatus = (e: SelectChangeEvent) => {
    onStatusChange(e.target.value as 'all' | TemplateStatus);
  };

  return (
    <Stack direction="row" spacing={2} alignItems="center" sx={{ px: 1 }}>
      <TextField
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search for templates"
        size="small"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />

      <Select
        size="small"
        value={status}
        onChange={handleStatus}
        sx={{ minWidth: 160 }}
        displayEmpty
      >
        <MenuItem value="all">All statuses</MenuItem>
        <MenuItem value="active">Active</MenuItem>
        <MenuItem value="inactive">Inactive</MenuItem>
      </Select>
    </Stack>
  );
}
